import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { Lender, LenderContact } from '@/models/bank-models.model';


@Injectable({
  providedIn: 'root'
})
export class LenderContactsService {
  lenders = signal<Lender[]>([]);
  base_url = environment.landmark_API_URL+'/lenders';

  dialogVisible = signal<boolean>(false);

  selectedLender = signal<Lender | null>(null);

  selectedContact = signal<LenderContact | null>(null);

  contactEdit = signal<boolean>(false);

  constructor(private http: HttpClient, private messageService: MessageService) { }

  getLenderContacts() {
    const response = this.http.get(`${this.base_url}/all`);
    response.subscribe((data: any) => {
      this.lenders.set(data);
    });
  }

  setSelectedContact(contact: LenderContact | null) {
    this.selectedContact.set(contact);
  }

  setContactEdit(edit: boolean) {
    this.contactEdit.set(edit);
  }

  onSave() {
    const contact = this.selectedContact();
    if(contact) {
      if(contact.contactId) {
        this.updateContact(contact);
      } else {
        this.saveNewContact(contact);
      }
    }
  }

  updateContact(contact: LenderContact) {
    if(contact.contactId) {
      console.log('patching contact', contact);
    const response = this.http.patch(`${this.base_url}/contacts/${contact.contactId}`, contact);
    response.subscribe((data: any) => {
      console.log('contact', data);
      const lender = this.lenders().find(l => l.LenderID === contact.LenderID);
      if (lender) {
        lender.LenderContacts = [...(lender.LenderContacts || []), contact];
      }
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact updated' });
      this.setContactEdit(false);
      this.setSelectedContact(null);
    }, (error: any) => {
      console.log('error', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error updating contact' });
      });
    }
  }

  saveNewContact(contact: LenderContact) {
    const response = this.http.post(`${this.base_url}/contacts/`, contact);
    response.subscribe((data: any) => {
      console.log('contact', data);
      const lender = this.lenders().find(l => l.LenderID === contact.LenderID);
      if (lender) {
        lender.LenderContacts = [...(lender.LenderContacts || []), contact];
      }
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact saved' });
      this.setContactEdit(false);
      this.setSelectedContact(null);
    }, (error: any) => {
      console.log('error', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error saving contact' });
    });
  }

  deleteContact(contactId: number) {
    const response = this.http.delete(`${this.base_url}/contacts/${contactId}`);
    response.subscribe((data: any) => {
      console.log('contact', data);
      const lender = this.lenders().find(l => l.LenderID === data.LenderID);
      if (lender) {
        lender.LenderContacts = lender.LenderContacts?.filter(c => c.contactId !== contactId) || [];
      }
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact deleted' });
    }, (error: any) => {
      console.log('error', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error deleting contact' });
    });
  }



}
